// src/lib/posthogService.ts
import { posthog, isPostHogEnabled } from './posthog';
import type { UserProfile } from '../types/api';

interface TrackProperties {
  [key: string]: string | number | boolean | null | undefined;
}

class PostHogService {
  private isEnabled(): boolean {
    return isPostHogEnabled();
  }

  identify(user: UserProfile): void {
    if (!this.isEnabled()) return;

    const userId = String(user.id);
    const name = user.username || `${user.first_name || ''} ${user.last_name || ''}`.trim();

    posthog.identify(userId, {
      email: user.email,
      name: name || undefined,
      first_name: user.first_name,
      last_name: user.last_name,
      username: user.username,
      subscription_tier: user.subscription?.tier || 'free',
      is_staff: user.is_staff || false,
    });

    posthog.register({
      subscription_tier: user.subscription?.tier || 'free',
      user_id: userId,
    });
  }

  reset(): void {
    if (!this.isEnabled()) return;

    posthog.reset();
  }

  track(eventName: string, properties?: TrackProperties): void {
    if (!this.isEnabled()) return;

    posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
  }

  trackPageView(pageName: string, additionalProps?: TrackProperties): void {
    if (!this.isEnabled()) return;

    posthog.capture('$pageview', {
      page_name: pageName,
      page_path: window.location.pathname,
      $current_url: window.location.href,
      referrer: document.referrer || undefined,
      ...additionalProps,
    });
  }
}

export const posthogService = new PostHogService();
